module.exports = __webpack_public_path__ + "static/media/banner-faq.8501adfc.jpg";